var render, staticRenderFns
import script from "./Vue2LeafletCustomMarker.vue?vue&type=script&lang=js&"
export * from "./Vue2LeafletCustomMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da599e0",
  null
  
)

export default component.exports